// extracted by mini-css-extract-plugin
export var active = "_fe-2";
export var recordingDot = "_fe-1";
export var recordingIndicator = "_fe-0";